/**
 * Plan-side day nutrition totals.
 *
 * A saved meal-plan row's nutrition only counts toward a day's macro total
 * when it is actually part of the day. `skipped` and `replaced` rows are NOT
 * eaten, so they must never contribute to the displayed day totals — this
 * mirrors the backend's ACTIVE_DAY_STATUSES (pending / completed / planned,
 * see backend/services/day_status.py) and how Swap and Progress already
 * exclude them.
 *
 * NOTE: this is only about the NUTRITION CONTRIBUTION. Skipped/replaced rows
 * may still be shown in historical/visual UI on purpose; that is unaffected.
 */

// Statuses whose macros must NOT be summed into a day's nutrition total.
export var DAY_NUTRITION_EXCLUDED_STATUSES = ['skipped', 'replaced'];

export function countsTowardDayNutrition(status) {
  return DAY_NUTRITION_EXCLUDED_STATUSES.indexOf(status) === -1;
}

/**
 * Sum {calories, protein, carbs, fat} across meal rows, excluding
 * skipped/replaced rows. Optionally restrict to a single meal_type.
 */
export function sumDayMacros(meals, mealType) {
  var totals = { calories: 0, protein: 0, carbs: 0, fat: 0 };
  (meals || []).forEach(function (m) {
    if (!m) return;
    if (mealType && m.meal_type !== mealType) return;
    if (!countsTowardDayNutrition(m.status)) return;
    var macros = m.macros || {};
    totals.calories += macros.calories || 0;
    totals.protein += macros.protein || 0;
    totals.carbs += macros.carbs || 0;
    totals.fat += macros.fat || 0;
  });
  return totals;
}
